import { axiosInstance } from "../../utils/axios";
//import { ExternalConfigs } from "../models/external-configs";

export function getExternalConfigs(): Promise<any> {
  return axiosInstance
    .get("/externalConfigs")
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      // eslint-disable-next-line no-undef
      console.error("Error fetching external configs:", error);
      throw error;
    });
}
